/* src/components/Layout/TopNavLayout.jsx */
import React from "react";
import { Outlet } from "react-router-dom";
import PagesTopNav from "../TopNav/PagesTopNav";   // ← the nav bar you just edited
import "./TopNavLayout.css";                      // optional style

const TopNavLayout = () => (
  <>
    <PagesTopNav />              {/* always visible */}
    <main className="top-layout-content">
      <Outlet />                 {/* ← child route (kyc‑upload…) renders here */}
    </main>
  </>
);

export default TopNavLayout;
